const progressScrollBar = document.querySelector('.progressScroll div')
const scrollElement = document.querySelector('.slideshow-list')

let scrollElementSize = scrollElement.offsetWidth
let scrollXElement = window.pageYOffset /// scrolltrigger invert axes


window.addEventListener('wheel', (e) => {
    scrollXElement =  window.pageYOffset

    const scaleProgressBar = scrollXElement / scrollElementSize
    progressScrollBar.style.transform = `scaleX(${scaleProgressBar > 1 ? 1 : scaleProgressBar})`
})